module.exports = __webpack_public_path__ + "img/crsl-impf-4.6c426ca6.png";